import { render, staticRenderFns } from "./CRResultsSingle.vue?vue&type=template&id=6bb2cbf3&scoped=true"
import script from "./CRResultsSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./CRResultsSingle.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CRResultsSingle.vue?vue&type=style&index=0&id=6bb2cbf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb2cbf3",
  null
  
)

export default component.exports